// Homepage location slider section

jQuery(document).ready(function() {
  // add active class to first item on page load so that only one is displayed
  jQuery('.location-list .location-item').first().addClass('active');
  jQuery('.location-links .location-link-item').first().addClass('active-link');

  //toggle active class for items to switch item is displayed
  jQuery('#location-1-title').click(function(){
    jQuery('#location-1').addClass('active');
    jQuery('#location-1').parent().children('li').not('#location-1').removeClass('active');

    jQuery('#location-1-title').addClass('active-link');
    jQuery('#location-1-title').parent().children('li').not('#location-1-title').removeClass('active-link');
  });

  jQuery('#location-2-title').click(function(){
    jQuery('#location-2').addClass('active');
    jQuery('#location-2').parent().children('li').not('#location-2').removeClass('active');

    jQuery('#location-2-title').addClass('active-link');
    jQuery('#location-2-title').parent().children('li').not('#location-2-title').removeClass('active-link');
  });

  jQuery('#location-3-title').click(function(){
    jQuery('#location-3').addClass('active');
    jQuery('#location-3').parent().children('li').not('#location-3').removeClass('active');

    jQuery('#location-3-title').addClass('active-link');
    jQuery('#location-3-title').parent().children('li').not('#location-3-title').removeClass('active-link');
  });

  jQuery('#location-4-title').click(function(){
    jQuery('#location-4').addClass('active');
    jQuery('#location-4').parent().children('li').not('#location-4').removeClass('active');

    jQuery('#location-4-title').addClass('active-link');
    jQuery('#location-4-title').parent().children('li').not('#location-4-title').removeClass('active-link');
  });

  // toggle .location-item with left/right arrows
  var locations = jQuery(".location-item");
  jQuery(".arrow-wrap").click(function(){
     var $activeLocation = jQuery(".active");
     jQuery($activeLocation).removeClass("active");
      if (jQuery(this).hasClass("right")){
           if (jQuery($activeLocation).next().hasClass("location-item")){
             jQuery($activeLocation).next().addClass("active");
           }
          else {
            jQuery(locations).first().addClass('active');
          }
      }
     else {
       if (jQuery($activeLocation).prev().hasClass("location-item")){
         jQuery($activeLocation).prev().addClass("active");
       }
       else {
         jQuery(locations).last().addClass('active');
       }
    }
  });

  // toggle .location-link-item with left/right arrows
  var locationLink = jQuery(".location-link-item");
  jQuery(".arrow-wrap").click(function(){
     var $activeLocationLink = jQuery(".active-link");
     jQuery($activeLocationLink).removeClass("active-link");
      if (jQuery(this).hasClass("right")){
           if (jQuery($activeLocationLink).next().hasClass("location-link-item")){
             jQuery($activeLocationLink).next().addClass("active-link");
           }
          else {
            jQuery(locationLink).first().addClass('active-link');
          }
      }
     else {
       if (jQuery($activeLocationLink).prev().hasClass("location-link-item")){
         jQuery($activeLocationLink).prev().addClass("active-link");
       }
       else {
         jQuery(locationLink).last().addClass('active-link');
       }
    }
  });

  //hide arrows if only one location
  if (jQuery('.location-item').length == 1) {
    jQuery('.arrow-wrap').hide();
    jQuery('.homepage-locations-footer').hide();
  }

});
